<template lang="pug">
button.app-pagination.btn(v-if="enableNext" @click="navigate(1)" :class="{ 'btn--secondary': siteName == 'ORG' }") LOAD MORE
</template>
  
<script>
import { mapGetters } from 'vuex';

export default {
  name: "AppPagination",
  props: ["currentPage", "enableNext", "navigate"],
  components: {},
  data() {
    return {};
  },
  computed: {
		...mapGetters([
			"siteName"
		]),
	},
  methods: {},
  created() { },
  mounted() { },
};
</script>

<style lang="scss" scoped>
.app-pagination {
  align-self: center;
}
</style>